export function convertImportFlagToString(importFlag: boolean | undefined) {
  if (importFlag) {
    return 'Tak';
  } else if (importFlag === false) {
    return 'Nie';
  } else {
    return 'B/D';
  }
}
